/* eslint-disable dot-notation */
import React, { useEffect } from 'react';
import { ThemeProvider, Button } from '@workboard/wobo-ui';
import { InitializeGoalCommentEditor } from '../../utils/editors';
import EmojiContainer from '../../components/emojis/emojis';
import GoalServices from '../../services/goal.services';
import { sanitize, isReadOnlyUserLicenseType } from '../../utils/common';
import { KeyDownEventLink } from '../../utils/eventKey'
import { useTranslation } from 'react-i18next';

const GoalSerivices = new GoalServices();

const CkEditorComp = ({
    goalId, comentId, activeEditor, focusEditor, comment, resetActiveEditor, comentActions
}) => {
    const {t} = useTranslation()
    const editorId = `goal_comment_edit_editor_${comentId || goalId}`;
    const cancelComment = (e) => {
        resetActiveEditor('');
        const commentParent = document.getElementById(`del-comment-${comentId}`);
        if (e.key !== undefined) {
            setTimeout(() => {
                if (commentParent) {
                    commentParent.focus();
                }
            });
        }
    }
    const  isReadOnlyEnabled = isReadOnlyUserLicenseType();

    useEffect(() => {
        let editor = CKEDITOR.instances[editorId];
        if (goalId !== null || (comentId && activeEditor == editorId)) {
            if (editor) {
                editor.destroy(true);
            } else {
                InitializeGoalCommentEditor(editorId);
            }
            editor = CKEDITOR.instances[editorId];
            if (!editor) {
                InitializeGoalCommentEditor(editorId);
            }
        }
    }, [goalId, comentId]);

    useEffect(() => {
        setTimeout(() => {
            const editor = CKEDITOR.instances[editorId];
            const range = editor.createRange();

            if (focusEditor) {
                editor.focus();
                range.moveToElementEditEnd(range.root);
                editor.getSelection().selectRanges([range]);
            }
        }, 1000)
    }, [focusEditor])

    const saveComment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let cvalue = CKEDITOR.instances[editorId].getData();
        if (cvalue != 'undefined' && cvalue.trim()) {
            cvalue = sanitize(cvalue.trim());
        } else {
            alert(t('Please enter the comment.'));
            return;
        }
        const params = {
            comment: cvalue,
        };
        if (comentId) {
            params['id'] = comentId;
        }
        if (goalId) {
            params['goal_id'] = goalId;
        }
        const newComment = `<div>${cvalue}</div>`;
        const aElements = $(newComment).find('div.selectedUser');
        const tElements = $(newComment).find('div.selectedTeam');
        let mentionId = $('.hiddenUserId').val();
        let mentionTeamId = '';
        const ids = []; const
            teamIds = [];
        if (aElements) {
            $(aElements).each(function () {
                const a = $(this).attr('class')
                const spanText = $(this).text();
                if (a.includes('selectedUser') && $(`.hiddenUserName_${editorId}`).val() != '') {
                    const addedArray = JSON.parse(($(`.hiddenUserName_${editorId}`)as any).val());
                    const atMentionId = a.split('selectedUser ')[1];
                    const mentionName = addedArray[`user_${atMentionId}`];
                    if (
                        mentionName != undefined
                        && spanText.indexOf(`@${mentionName}`) !== -1
                        && ids.indexOf(atMentionId) === -1
                    ) {
                        ids.push(atMentionId);
                    }
                }
            });
            mentionId = ids.join(',');
        }
        if (tElements) {
            $(tElements).each(function () {
                const a = $(this).attr('class')
                if (a.includes('selectedTeam')) {
                    const atMentionId = a.split('selectedTeam ')[1];
                    if (!teamIds.includes(atMentionId)) {
                        teamIds.push(atMentionId);
                    }
                }
            });
            mentionTeamId = teamIds.join(',');
        }
        params['mentioned_user_id'] = mentionId;
        params['mentioned_team_id'] = mentionTeamId;
        params['source_from'] = 'okrdetails';
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        if (comentId) {
            cancelComment(e);
        }
        GoalSerivices.saveComment(params).then((response) => {
            if (response.data.error) {
                removeLoader();
                alert(response.data.error);
                console.error(
                    'Response Error: ',
                    response.data.error
                );
            } else if (response.data.data) {
                if (goalId) { // add
                    CKEDITOR.instances[editorId].setData('');
                    comentActions({ action: 'add', object: response.data.data });
                    removeLoader();
                } else if (comentId) { // edit
                    comentActions({ action: 'edit', object: response.data.data, id: comentId });
                    removeLoader();
                }
            }
        });
    }

    const wrapperClass = (goalId != null) ? 'comment-input-box' : 'edit-comment-input-box';
    return (
        <>
            <ThemeProvider>
                {!isReadOnlyEnabled && (<div className="editor_main_wrap">
                    <div className={wrapperClass}>
                        <textarea
                            className="goal_comment_edit_editor"
                            id={editorId}
                            placeholder={t("Add a comment")}
                            value={comment}
                        />
                        <input type="hidden" className="hiddenUserId" value="" />
                        <input type="hidden" className={`hiddenUserName hiddenUserName_${editorId}`} value="" />
                        <div className="smiley-container">
                            <EmojiContainer editorId={editorId} />
                        </div>
                    </div>
                    {goalId != null
                        && (
                            <input
                                type="button"
                                value={`${t("Post")}`}
                                className="gbl-btn gbl-btn-slim goal-post-button"
                                onClick={saveComment}
                            />
                        )}
                    {comentId
                        && (
                            <div className="goal-comment-edit-buttons comment-newBtns">
                                <Button
                                    variant="primary"
                                    onClick={saveComment}
                                    onKeyDown={(e) => { KeyDownEventLink(e, () => saveComment(e)) }}
                                >{t("Save")}
                                </Button>
                                <Button
                                    variant="ghost"
                                    onClick={e => cancelComment(e)}
                                    onKeyDown={(e) => { KeyDownEventLink(e, () => cancelComment(e)) }}
                                    style={{ marginLeft: '10px' }}
                                >{t("Cancel")}
                                </Button>
                            </div>
                        )}
                </div>)}
            </ThemeProvider>
        </>
    )
}

export default CkEditorComp;
